import ExpandToggle from "./expand-toggle.js";

const toggles = document.querySelectorAll("[data-expands]");

// ES6
toggles.forEach(el => new ExpandToggle(el));

// ES5
export default function loadToggles() {
  for (var i = 0, len = toggles.length; i < len; i++) {
    new ExpandToggle(toggles[i]);
  }
}
